import _defineProperty from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { useContext } from 'react';
import _Logo from './Areas/Logo';
import _MainMenu from './Areas/MainMenu';
import _CTAMenu from './Areas/CTAMenu';
import _UtilityMenu from './Areas/UtilityMenu';
import _ContactInformation from './Areas/ContactInformation/ContactInformation';
import _SocialMedia from './Areas/SocialMedia';
import HoursOfOperationArea from './Areas/HoursOfOperationArea';
import _Copyright from './Areas/Copyright';
import _ImageContent from './Areas/ImageContent';
import ContactInformationFullWidth from './Areas/ContactInformation/ContactInformationFullWidth';
import { Context } from '../../../global-state-context';
var componentsMap = {
  'Logo': function Logo(props) {
    return __jsx(_Logo, {
      footerLogo: props.footerLogo
    });
  },
  'CTA Menu': function CTAMenu(props) {
    return __jsx(_CTAMenu, {
      ctaMenuCollection: props.footer.ctaMenuCollection,
      openDropdownOnClick: true
    });
  },
  'Main Menu': function MainMenu(props) {
    return __jsx(_MainMenu, {
      mainMenuCollection: props.footer.mainMenuCollection,
      openDropdownOnClick: true
    });
  },
  'Utility Menu': function UtilityMenu(props) {
    return __jsx(_UtilityMenu, {
      items: props.footer.utilityMenuCollection.items
    });
  },
  'Contact Information': function ContactInformation(props) {
    return __jsx(_ContactInformation, {
      items: props.footer.contactInformationCollection.items,
      yextContactInformationData: props.yextContactInformationData
    });
  },
  'Social Media': function SocialMedia(props) {
    return __jsx(_SocialMedia, {
      socialMedia: props.footer.socialMedia,
      siteName: props.siteName
    });
  },
  'Hours of Operation': function HoursOfOperation(props) {
    return __jsx(HoursOfOperationArea, {
      yextContactInformationData: props.yextContactInformationData
    });
  },
  'Divider': function Divider() {
    return __jsx("span", {
      className: "nva-footer__divider"
    });
  },
  'Copyright': function Copyright() {
    return __jsx(_Copyright, null);
  },
  'Image Content': function ImageContent(props) {
    return __jsx(_ImageContent, {
      imageContentCollection: props.footer.imageContentCollection.items
    });
  }
};
var componentsMapFullWidth = _objectSpread(_objectSpread({}, componentsMap), {}, {
  'Contact Information': function ContactInformation(props) {
    return __jsx(ContactInformationFullWidth, {
      items: props.footer.contactInformationCollection.items,
      yextContactInformationData: props.yextContactInformationData
    });
  }
});
var FooterItem = function FooterItem(props) {
  var _componentsMap$props$;
  var _useContext = useContext(Context),
    predefinedTheme = _useContext.predefinedTheme;
  if (predefinedTheme === 'Full Width') {
    var _componentsMapFullWid;
    return (_componentsMapFullWid = componentsMapFullWidth[props.component]) === null || _componentsMapFullWid === void 0 ? void 0 : _componentsMapFullWid.call(componentsMapFullWidth, props);
  }
  return (_componentsMap$props$ = componentsMap[props.component]) === null || _componentsMap$props$ === void 0 ? void 0 : _componentsMap$props$.call(componentsMap, props);
};
export default FooterItem;